@if (fieldItem) {
  <span
    [class]="viewName"
    [ngClass]="{'multiple-values': fieldItem.field_values.values.length > 1,
                'content-has-icon': fieldItem.field_values.field_icon}"
  >
    @if (fieldItem.field_values.field_icon) {
      @if (useMaterialSymbols) {
        <mat-icon class="material-symbols-outlined field-icon">
          {{ iconToMaterialSymbol(fieldItem.field_values.field_icon.icon) }}
        </mat-icon>
      }
      @else {
        <i class="{{fieldItem.field_values.field_icon.icon}}">
          {{fieldItem.field_values.field_icon.icon_frame}}
        </i>
      }
    }

    @for (value of fieldItem.field_values.values; track $index) {
      <ng-container>
        @if (!valueIsRef(value)) {
          <span
            [innerHTML]="value.value"
            [ngClass]="{'text-value': fieldItem.field_values.values.length === 1}"
          >
            @if (!last) {
              <span>, </span>
            }
          </span>
        }
        @else {
          <span>
            @if (value.$$linkItems) {
              <app-overview-field-link
                [toneDownTextColor]="toneDownTextColor"
                [items]="value.$$linkItems"
                [stylingClass]="viewName"
                [disableLinks]="disableLinks"
                [useMaterialSymbols]="useMaterialSymbols"
              ></app-overview-field-link>
            }
          </span>
        }
      </ng-container>
    }
  </span>
}
